import {getSpellColorCode} from "/src/utilities.js";
import {imageUrls,hidden} from "/src/imgResources.js";
import {enterQuizClickACB} from "../utilities.js"

export function SearchDetailView(props) {
    return (
        <div className="universal-margin universal-padding">
            <button type="button" className="btn btn-light floating-btn" onClick={enterQuizClickACB}>Start Quiz</button>
            <button class="btn mb-3"  onClick={handleBackButtonACB}>Previous Page</button>
            <div className="card universal-padding">
            <div className="row">
                <div className="col-sm-3 ">
                {props.page !== 'Spells'? (<img className="card-img-top square-img" src={props.page === 'Houses' ? imageUrls[props.detailResult.name] || hidden
                            : props.page === 'Elixirs' ? (props.detailResult.image || hidden) 
                            : props.page === 'Characters' ? (props.detailResult.image || hidden)
                            : hidden} alt="Card image" />)
                            : (getSpellColorCode(props.detailResult.light) ? <div class="card-img-top square-img" style={{ height: '40vh', backgroundImage: `radial-gradient(${getSpellColorCode(props.detailResult.light)}, white, #EFEEED)`, border: `1px solid #EFEEED` }}></div> : 
                            <img class="card-img-top square-img" src={hidden} alt={`${props.detailResult.name} Image`} onError={hidden}/>
                        )
                }
                </div>
                <div className="col-sm-1"></div>
                <div className="col-sm">
                <h1 className=" harry-font">{props.detailResult.name}</h1>
                    
                    {props.page === 'Elixirs' && (
                    <div >
                        <p>Effect: {props.detailResult.effect  || 'None'}</p>
                        <p>Side Effect: {props.detailResult.sideEffects  || 'None'}</p>
                        <p>Characteristics: {props.detailResult.characteristics  || 'None'}</p>
                        <p>Difficulty: {props.detailResult.difficulty  || 'None'}</p>
                        <p>Ingredients: {formatIngredients(props.detailResult.ingredients  || 'None')}</p>
                        <p>Inventors: {formatInventors(props.detailResult.inventors  || 'None')}</p>
            
                    </div>
                )}
                {props.page === 'Houses' && (
                    <div>
                        <p>House Colors: {props.detailResult.houseColours}</p>
                        <p>Founder: {props.detailResult.founder}</p>
                        <p>Animal: {props.detailResult.animal}</p>
                        <p>Element: {props.detailResult.element}</p>
                        <p>Ghost: {props.detailResult.ghost}</p>
                        <p>Common Room: {props.detailResult.commonRoom}</p>
                        <p>Heads: {formatHeads(props.detailResult.heads  || 'None')}</p>
                        <p>Traits: {formatTraits(props.detailResult.traits  || 'None')}</p>
                    </div>
                )}
                {props.page === 'Spells' && (
                    <div>
                    <p>Incantation: {props.detailResult.incantation || 'None'}</p>
                    <p>Effect: {props.detailResult.effect || 'None'}</p>
                    <p>Can Be Verbal: {props.detailResult.canBeVerbal || 'None'}</p>
                    <p>Type: {props.detailResult.type || 'None'}</p>
                    <p>Light: {props.detailResult.light || 'None'}</p>
                    <p>Creator: {props.detailResult.creator}</p>
                </div>)}

                {props.page === 'Characters' && (
                    <div>
                    <p>Also known as: {formatNames(props.detailResult.alternate_names || 'None')}</p>
                    <p>Species: {props.detailResult.species || 'None'}</p>
                    <p>Gender: {props.detailResult.gender || 'None'}</p>
                    <p>House: {props.detailResult.house || 'None'}</p>
                    <p>Ancestry: {props.detailResult.ancestry || 'None'}</p>
                    <p>Hair Colour: {props.detailResult.hairColour || 'None'}</p>
                    <p>Wand: {formatWand(props.detailResult.wand  || 'None')}</p>
                    <p>Patronus: {props.detailResult.patronus || 'None'}</p>
                </div>
                
                )}</div>
            </div>
                
            </div>
        </div>
    );

    function formatIngredients(ingredients) {
        return ingredients && ingredients.length > 0 ? ingredients.map(ingredient => ingredient.name).join(", ") : 'Unknown';
    }

    function formatNames(details) {
        return details && details.length > 0 ? details.join(", ") : 'Unknown';
    }

    function formatTraits(traits) {
        return traits && traits.length > 0 ? traits.map(trait => trait.name).join(", ") : 'Unknown';
    }

    function formatInventors(inventors) {
        return inventors && inventors.length > 0 ? inventors.map(inventor => `${inventor.firstName} ${inventor.lastName}`).join(", ") : 'Unknown';
    }

    function formatHeads(heads) {
        return heads && heads.length > 0 ? heads.map(head => `${head.firstName} ${head.lastName}`).join(", ") : 'Unknown';
    }

    function formatWand(wand) {
        return wand && wand.length > 0 ? `${wand.wood} wood with ${wand.core} core` : 'Unknown';
    }

    function handleBackButtonACB() {
        window.location.hash = "/search";
    }
}
